import { render } from "./maintenance_message.vue?vue&type=template&id=586130d7"
import script from "./maintenance_message.vue?vue&type=script&lang=js"
export * from "./maintenance_message.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__